import { Phone, MessageCircle } from 'lucide-react';
import { BUSINESS } from '../data/content';

export default function StickyButtons() {
  return (
    <>
      <a data-testid="sticky-call-btn" href={`tel:${BUSINESS.phoneRaw}`}
        className="fixed bottom-5 left-5 z-50 bg-forest text-white rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform w-14 h-14 grid place-items-center lg:hidden"
        aria-label="Call Laraé Logistics">
        <Phone size={22} />
      </a>
      <a data-testid="sticky-whatsapp-btn" href={`https://wa.me/${BUSINESS.whatsappRaw}?text=Hi%20Lara%C3%A9%20Logistics%2C%20I%27d%20like%20a%20quote.`}
        target="_blank" rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] text-white rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform w-14 h-14 grid place-items-center"
        aria-label="WhatsApp Laraé Logistics">
        <MessageCircle size={22} />
      </a>
    </>
  );
}
